export interface RateRecipeAction {
  type: 'API/RATE_RECIPE';
  payload: {
    recipeId: number;
    value: number;
  };
}

export function rateRecipe(recipeId: number, value: number): RateRecipeAction {
  return {
    type: 'API/RATE_RECIPE',
    payload: {
      recipeId,
      value,
    },
  };
}
